<div class="tab-body">
  <form [formGroup]="addItemPriceForm">
    <div class="form-inputs form-dropdown curr-unit">
      <p class="paragraph-medium-regular">Unit of Measurement (UOM) *</p>
      <ng-select [items]="UOMdropdown" appearance="outline" bindLabel="value" (change)="CalculateEastimateCost($event)"
        [readonly]="isReadOnly" formControlName="UnitOfMeasurement"></ng-select>

        
    </div>
    <div class="form-inputs form-padding">
      <p class="paragraph-medium-regular">Quantity *</p>
      <input class="normal-txtbox" type="number" min="0" max="9999999999999.999" formControlName="Quantity" step="0.001"
        (change)="CalculateEastimateCost($event)" placeholder="0.000" (input)="restrictNegativeNumberInput($event, 3)"
        [readonly]="isReadOnly" />
    </div>
    <div class="form-inputs form-padding">
      <div class="budget-tooltip-block">
      <p class="paragraph-medium-regular">Units per quantity (per) *</p>
      <input class="normal-txtbox" type="number" min="0" max="9999999999999.99" formControlName="UnitsPerQuantity"
        step="0.01" (change)="CalculateEastimateCost($event)" placeholder="0.00"
        (input)="restrictNegativeNumberInput($event,2)" [readonly]="isReadOnly" />
        <ng-template #tooltipTemplateInfo>
          <div class="custom-tooltip">
            <p>
              <strong><u>Example: Unit Price is > 2 decimal places</u></strong>
              <br/>
              <br/>
              Vendor quoted price of 1 resistor = $0.011 (3 decimal places)
              <br/>
              System can only accept 2 decimal places. To keep the unit price within 2 decimal places, key in <strong>“Unit Per Qty=10”</strong> so that PO can be raised downstream.
              <br/>
              <br/>
              Qty = 1000
              <br/>
              Per = 10
              <br/>
              Unit Price = $0.11 (2 decimal places)
              <br/>
              <br/>
              Estimated Item Amount = (Qty/Per) x $Unit Price = (1000/10) x $0.11 = $11
              <br/>
          
            </p>
          </div>
        </ng-template>
        <mat-icon [tp]="tooltipTemplateInfo" 
        tpClassName="custom-tooltip" tpMaxWidth="500px" [tpInteractive]="true" tpPlacement="bottom">help</mat-icon>
      </div>
    </div>
    <div class="curr-div">
      <div class="form-inputs form-dropdown">
        <p class="paragraph-medium-regular">Currency*</p>
        <ng-select [items]="Currdropdown" appearance="outline" bindLabel="value"
          (change)="CalculateEastimateCost($event)" formControlName="Currency" [readonly]="isReadOnly"></ng-select>
      </div>
      <div class="curr-price">
        <div class="budget-tooltip-block">
        <p class="paragraph-medium-regular">Unit price *</p>
        <input class="normal-txtbox" type="number" min="0" max="9999999999999.99" formControlName="UnitPrice"
          step="0.01" (change)="CalculateEastimateCost($event)" placeholder="0.00"
          (input)="restrictNegativeNumberInput($event, 2)" [readonly]="isReadOnly" />
          <ng-template #tooltipTemplatePrice>
            <div class="custom-tooltip">
              <p>
                Is the price per UOM.
                <br/>
              </p>
            </div>
          </ng-template>
          <mat-icon [tp]="tooltipTemplatePrice" 
          tpClassName="custom-tooltip" tpMaxWidth="500px" [tpInteractive]="true" tpPlacement="bottom">help</mat-icon>
        </div>
      </div>
    </div>
    <div *ngIf="currencyExchangeError" style="transform: translateX(-193px); color:red">The currency selected is not
      available. Please contact PMM for assistance. </div>
    <div class="curr-price-msg">
      <p class="curr-price-amt heading-h6-regular">Estimated item amount: <span
          *ngIf="this.addItemPriceForm.controls['Currency'].getRawValue() && this.addItemPriceForm.controls['Currency'].getRawValue().value">{{
          totalPrice }}</span></p>
      <p class="curr-price-amt paragraph-medium-regular"
        *ngIf="this.addItemPriceForm.controls['Currency'].getRawValue() && this.addItemPriceForm.controls['Currency'].getRawValue().value!='SGD'">
        Currency
        Exchange: {{
        currencyExchangeText }}</p>
      <span class="paragraph-medium-medium">Formula = (Quantity / Units per quantity) * Unit price</span>
    </div>
  </form>
</div>